import { render, staticRenderFns } from "./AppHeaderSpMenu.vue?vue&type=template&id=b1b42cea&scoped=true"
import script from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppHeaderSpMenu.vue?vue&type=style&index=0&id=b1b42cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b42cea",
  null
  
)

export default component.exports